import { ComponentProps } from "react";
import { Root } from "@radix-ui/react-dialog";

export const Sheet = ({ ...props }: ComponentProps<typeof Root>) => {
    return <Root data-slot="sheet" {...props} />
}